import styled from "styled-components";
import { Wrapper } from 'AppReact';
import { colorShade } from "utils";

export const template = styled.span`
  position: absolute;
  z-index: 10;
  width: 100%;
  height: 100%;
  left: 0px;
  top: 0px;
  align-items: center;
  background: ${colorShade(0.9, window?.settings?.primary_color ?? '#1DBD6B')};
  justify-content: center;
  border-radius: 12px;
`;

export default Wrapper(template);